import React from 'react';
import UserLayout from '../../components/Layout/UserLayout';
import Dashboard from './Dashboard';
import messages from '../../locale/jsonMessages';

export default async function action({ store, intl }) {

  const title = intl?.formatMessage(messages.dashboard);

  // From Redux Store
  let isAuthenticated = store.getState().runtime.isAuthenticated;

  if (!isAuthenticated) {
    return { redirect: '/login' };
  }

  return {
    title,
    component: <UserLayout><Dashboard title={title} /></UserLayout>,
  };
};
